import React from 'react'
import {  FiChevronRight, FiChevronLeft } from 'react-icons/fi'

export const popularCategories = [
    {name:'Video',img:'camera'},
    {name:'Music',img:'mic'},
    {name:'Trending',img:'car'},
    {name:'Programming',img:'code'},
    {name:'Business',img:'code1'},
    {name:'Lifestyle',img:'car2'},
    {name:'Writing & Translation',img:'office'},
] 

export const popularProjects = [ 
    {img:'snapchat',user:{name:'Ahmet Er', avatar:0}},
    {img:'spotify',user:{name:'Larry Murphy', avatar:1}},
    {img:'netflix',user:{name:'Brian Bell', avatar:2}},
    {img:'messenger',user:{name:'Alan Young', avatar:3}},
    {img:'discord',user:{name:'Anthony Carter', avatar:4}},
    {img:'figma',user:{name:'Judy Foster', avatar:5}},
    {img:'aedin',user:{name:'Linda Patterson', avatar:6}},
    {img:'imessage',user:{name:'Henry Gray', avatar:7}},
    {img:'instagram',user:{name:'Rosie Khan', avatar:8}},
    {img:'instagram2',user:{name:'Ahmet Mehmet Er', avatar:9}},
    {img:'tiktok',user:{name:'Dan Andrews', avatar:10}},
    {img:'twitter',user:{name:'Javier Farmer', avatar:11}},
    {img:'twitter2',user:{name:'Clifton Roberson', avatar:12}},
    {img:'youtube',user:{name:'Ahmet Er', avatar:0}},
    {img:'tesla',user:{name:'Brandy Webb', avatar:13}},
    {img:'spotify2',user:{name:'Ahmet Er', avatar:0}},
    {img:'tesla2',user:{name:'Seth Richards', avatar:14}},
    {img:'whatsapp',user:{name:'Ramona Murray', avatar:15}},
]

export const defaultSettings = {
    arrows:true,
    dots:true,
    infinite: true,
    speed: 500,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 2500,
    slidesToShow: 4,
    slidesToScroll: 3,
    //rtl:true,
    // initialSlide:1,
    wipe:true,
    wipeToSlide:true,
    prevArrow:<div className="prev-btn btn"><FiChevronLeft /> </div>,
    nextArrow:<div className="next-btn btn"><FiChevronRight /> </div>,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        } 
      ]
};

export const featuredPosts = [
    {img:0,user:{name:'Ahmet Er', avatar:0},},
    {img:1,user:{name:'Larry Murphy', avatar:1},},
    {img:2,user:{name:'Brian Bell', avatar:2},},
    {img:3,user:{name:'Alan Young', avatar:3},},
    {img:4,user:{name:'Anthony Carter', avatar:4},},
    {img:5,user:{name:'Judy Foster', avatar:5},},
    {img:6,user:{name:'Linda Patterson', avatar:6},},
    {img:7,user:{name:'Henry Gray', avatar:7},},
    {img:8,user:{name:'Rosie Khan', avatar:8},},
    {img:9,user:{name:'Ahmet Mehmet Er', avatar:9},},
    {img:10,user:{name:'Dan Andrews', avatar:10},},
    {img:11,user:{name:'Javier Farmer', avatar:11},},
    {img:12,user:{name:'Clifton Roberson', avatar:12},},
    {img:13,user:{name:'Brandy Webb', avatar:13},},
    {img:14,user:{name:'Seth Richards', avatar:14},},
    {img:15,user:{name:'Ramona Murray', avatar:15},},
];
